import * as React from "react";
import { graphql } from "gatsby";
import { Trans, useTranslation } from "react-i18next";
import LandingLayout from "../../components/page-layout/LandingLayout";
import TextHero from "../../components/hero/TextHero";
import { LandingCta } from "../../components/cta/LandingCta";
import ClientsSections from "../../components/sections/ClientsSection";
import { TestimonialsSlider } from "../../components/sections/TestimonialsSlider";
import { Comparison } from "../../components/Comparison";
import TextCta from "../../components/cta/TextCta";
import { useScheduleCallUrl } from "../../hooks/useScheduleCallUrl";
import { useServiceTree } from "../../hooks/useServiceTree";
import TechIcon from "../../components/icons/TechIcon";
import { FeaturesGrid3 } from "../../components/features-grid/FeaturesGrid3";

const ShortLanding = () => {
  const { t } = useTranslation();
  const callUrl = useScheduleCallUrl();
  const services = useServiceTree();

  return (
    <LandingLayout darkHeader>
      <TextHero
        dark
        extraWide
        center={false}
        tag="astrorei"
        topCta={
          <p className="text-lg text-gray-200">
            {t("landing:digital.hero.tag")}
          </p>
        }
        title={
          <Trans
            i18nKey="landing:digital.hero.title"
            components={{ light: <span className="font-normal" /> }}
          />
        }
        description={t("landing:digital.hero.description")}
        cta={
          <LandingCta
            label={t("landing:digital.hero.cta.button")}
            theme="dark"
            className="mt-8"
          />
        }
      />
      <ClientsSections border={false} />

      <Comparison
        pros={t(`landing:digital.comparison.pros`, {
          returnObjects: true,
        })}
        cons={t(`landing:digital.comparison.cons`, {
          returnObjects: true,
        })}
      />

      <TextCta
        noMargin="no-margin"
        theme="white"
        tag={t(`landing:digital.cta2.tag`)}
        title={t(`landing:digital.cta2.title`)}
        cta={
          <LandingCta
            theme="white"
            center
            label={t("landing:digital.cta2.button")}
            notes={
              <Trans
                i18nKey="landing:digital.cta2.notes"
                components={{
                  a: (
                    <a
                      href={callUrl}
                      target="_blank"
                      className="text-primary underline"
                    />
                  ),
                }}
              />
            }
          />
        }
      />

      <FeaturesGrid3
        theme="gray"
        tag={t(`landing:digital.solutions.tag`)}
        title={t(`landing:digital.solutions.title`)}
        elements={services
          .find((s) => s.id === "customSoftwareSolutions")!
          .solutions.map((solution) => ({
            name: t(`solutions:${solution.id}.name`),
            icon: (
              <TechIcon
                size="xl"
                icon={solution.icon}
                className="text-gray-900 overflow-hidden"
              />
            ),
          }))}
      />

      <TestimonialsSlider />
    </LandingLayout>
  );
};

export default ShortLanding;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
